var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "key"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_883_179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_883_179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "key_2",
    d: "M4.66667 10C5.22222 10 5.69445 9.80556 6.08333 9.41667C6.47222 9.02778 6.66667 8.55556 6.66667 8C6.66667 7.44444 6.47222 6.97222 6.08333 6.58333C5.69445 6.19444 5.22222 6 4.66667 6C4.11111 6 3.63889 6.19444 3.25 6.58333C2.86111 6.97222 2.66667 7.44444 2.66667 8C2.66667 8.55556 2.86111 9.02778 3.25 9.41667C3.63889 9.80556 4.11111 10 4.66667 10ZM4.66667 12C3.55556 12 2.61111 11.6111 1.83333 10.8333C1.05556 10.0556 0.666668 9.11111 0.666668 8C0.666668 6.88889 1.05556 5.94444 1.83333 5.16667C2.61111 4.38889 3.55556 4 4.66667 4C5.56667 4 6.35278 4.25556 7.025 4.76667C7.69722 5.27778 8.16667 5.91111 8.43334 6.66667H14.0167L15.3333 7.98333L13 10.65L11.3333 9.33333L10 10.6667L8.66667 9.33333H8.43334C8.15556 10.1333 7.67222 10.7778 6.98334 11.2667C6.29445 11.7556 5.52222 12 4.66667 12Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ab2988cbeca3d51265bd0623886ea8a0.svg";
export { ForwardRef as ReactComponent };